import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { CommonService } from '../../../modules/reports/services/common/common.service';
import { NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from '../../../modules/reports/component/inspections-scheduled/ngb-date-fr-parser-formatter';
import { Widget } from '../../widget';

@Component({
  selector: 'app-widget-form-inline',
  templateUrl: './widget-form-inline.component.html',
  styleUrls: ['./widget-form-inline.component.scss'],
  providers: [{ provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }]
})
export class WidgetFormInlineComponent implements OnInit {
  @Input() widgetId: any = '';
  @Output() saved = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  widget = new Widget(null, '', '', 0, 0, null, '', null, null, null, null);
  branches = [];
  inspectors = [];
  dataSource = [];
  selectedSources = [];
  dropdownSettings = {};
  sourceSlugs = [];
  isJustCustom = false;
  inspectorCheck = false;
  dateRangeMode = false;
  submitted = false;
  isLoading = false;
  isEditMode = false;
  error = '';

  // Steps
  currentStep = 1;
  totalSteps = 3;

  googWidgets = [
    'google_sheet_SacramentoHome_C2', 'google_sheet_SacramentoHome_D2',
    'google_sheet_SacramentoPest_C2', 'google_sheet_SacramentoPest_D2',
    'google_sheet_AuburnHome_C2', 'google_sheet_AuburnHome_D2',
    'google_sheet_AuburnPest_C2', 'google_sheet_AuburnPest_D2',
    'google_sheet_VacavilleHome_C2', 'google_sheet_VacavilleHome_D2',
    'google_sheet_VacavillePest_C2', 'google_sheet_VacavillePest_D2',
    'google_sheet_SanDiegoHome_C2', 'google_sheet_SanDiegoHome_D2',
    'google_sheet_SanDiegoPest_C2', 'google_sheet_SanDiegoPest_D2',
    'google_sheet_DashboardTotals_B2', 'google_sheet_DashboardTotals_B4',
    'google_sheet_DashboardTotals_B6', 'google_sheet_DashboardTotals_B8'
  ];

  constructor(
    private sharedService: SharedService,
    private commonService: CommonService,
    private calendar: NgbCalendar
  ) {}

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.user_level !== 'inspector') {
      this.inspectorCheck = true;
      this.getInspectors();
    }
    this.getBranch();
    this.dataSources();
    this.widget.is_today = '1';

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
  }

  getBranch() {
    this.commonService.getBranch().subscribe(data => {
      this.branches = data;
    });
  }

  getInspectors() {
    this.commonService.getInspectors().subscribe(data => {
      this.inspectors = data;
    });
  }

  dataSources() {
    this.sharedService.getdataSources().subscribe(data => {
      this.dataSource = data;
      if (typeof this.widgetId === 'number') {
        this.loadWidget(this.widgetId);
      }
    });
  }

  loadWidget(id) {
    this.isLoading = true;
    this.isEditMode = true;
    this.sharedService.editWidget(id).subscribe(data => {
      this.isLoading = false;
      this.selectedSources = [];
      this.widget = new Widget(
        id, data['title'], data['data_source_id'], data['branch_id'],
        data['agent_id'], data['goal'], data['data_type'], data['is_today'],
        data['from_date'], data['to_date'], data['goal_completed']
      );
      if (data.widget_sources) {
        for (let i = 0; i < data.widget_sources.length; i++) {
          this.selectedSources.push({
            id: data.widget_sources[i].data_source_id,
            name: data.widget_sources[i].data_source.name,
            slug: data.widget_sources[i].data_source.slug
          });
        }
      }
      this.onItemSelect(data['data_source_id']);
      if (data['is_today'] == 0) {
        this.dateRangeMode = true;
        this.widget.is_today = '0';
      } else {
        this.widget.is_today = '1';
      }
    });
  }

  onItemSelect(event) {
    this.sourceSlugs = [];
    this.isJustCustom = false;
    for (let i = 0; i < this.dataSource.length; i++) {
      const id = this.dataSource[i]['id'];
      for (let k = 0; k < this.selectedSources.length; k++) {
        if (this.selectedSources[k]['id'] == id) {
          this.sourceSlugs.push(this.dataSource[i]['slug']);
        }
      }
    }
    if (this.sourceSlugs.length === 1 && this.sourceSlugs[0] === 'custom') {
      this.isJustCustom = true;
    }
  }

  changeDate(val) {
    this.dateRangeMode = val;
  }

  dateRangeSubmit(value) {
    this.widget.to_date = this.calendar.getToday();
    switch (value) {
      case '1':
        this.widget.from_date = this.calendar.getPrev(this.calendar.getToday(), 'd', 30);
        break;
      case '2':
        this.widget.from_date = this.calendar.getPrev(this.calendar.getToday(), 'd', 90);
        break;
      case '3':
        const date = (new Date()).getFullYear();
        this.widget.from_date = { year: date, month: 1, day: 1 };
        break;
    }
  }

  // Step navigation
  nextStep() {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  canProceedStep1(): boolean {
    return !!(this.widget.text && this.selectedSources.length > 0);
  }

  canProceedStep2(): boolean {
    return true; // Branch/inspector/date are optional
  }

  submitWidget() {
    this.submitted = false;
    this.widget.data_source_id = this.selectedSources;
    if (this.selectedSources.length > 0) {
      this.sharedService.addWidget(this.widget).subscribe(() => {
        this.saved.emit();
      });
    } else {
      this.submitted = true;
    }
  }

  cancel() {
    this.cancelled.emit();
  }
}
